import './FiUserDialog.scss';
import { FiFurnitureService } from '../fiFurniture/FiFurnitureService';

import * as angular from 'angular';

import { Component } from '../Component';

@Component({
    controllerAs: 'vm',
    template: require('./FiUserDialog.html'),
    bindings: {

    },
})
export class FiUserDialog {
    static $inject = [
        '$mdDialog',
        'fiFurnitureService',
    ];


    constructor(
        private $mdDialog: angular.material.IDialogService,
        private fs: FiFurnitureService,
    ) {
        //
    }

    $onInit() {
        // console.log(this.fs.userToView);
    }

    close() {
        this.$mdDialog.cancel();
    }
}